
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaderboards/duo/[[...slug]]",
      function () {
        return require("private-next-pages/leaderboards/duo/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaderboards/duo/[[...slug]]"])
      });
    }
  